import { Reveal, SectionHeading } from "./Reveal";

const STEPS = [
  {
    n: "01",
    title: "Walk & Soil Read",
    desc: "On-site inspection, soil analysis, and a straight answer on what your ground needs.",
  },
  {
    n: "02",
    title: "Excavate & Rough Grade",
    desc: "Heavy iron moves the bulk — cuts, fills, drainage paths shaped right the first time.",
  },
  {
    n: "03",
    title: "Fine Seedbed Prep",
    desc: "Final grading and soil conditioning until the bed is ready to hold seed and moisture.",
  },
  {
    n: "04",
    title: "Hydro-Mulch Application",
    desc: "Even slurry coverage with tackifier lock-in. Water it, and watch it go green.",
  },
];

export default function Process() {
  return (
    <section
      id="process"
      data-testid="process-section"
      className="mx-auto max-w-7xl px-4 py-24 sm:px-8 md:py-32 lg:px-16"
    >
      <SectionHeading
        overline="05 / How it goes down"
        title="Four steps. No surprises."
        testid="process-heading"
      />
      <div className="grid gap-px overflow-hidden rounded-md border border-[#1c4431]/15 bg-[#1c4431]/15 sm:grid-cols-2 lg:grid-cols-4">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={0.1 * i} className="h-full">
            <div
              data-testid={`process-step-${s.n}`}
              className="flex h-full flex-col bg-[#faf6ea] p-8 transition-colors duration-300 hover:bg-[#f1ead7]"
            >
              <span className="font-mono text-sm font-bold tracking-[0.3em] text-[#2e7d4f]">
                {s.n}
              </span>
              <h3 className="mt-6 font-display text-lg font-bold tracking-tight text-[#1a2e22]">
                {s.title}
              </h3>
              <p className="mt-3 text-sm leading-relaxed text-[#5c6b58]">
                {s.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </section>
  );
}
